import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'
import { Button } from 'react-bootstrap'
import { PresetKey, PRESETS } from './multi_use_presets'
import SelectableCard from './SelectableCard'

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.multi_use_rewards_card'
)

interface PresetCardGridProps {
  selectedPreset: PresetKey | null
  onPresetSelect: (preset: PresetKey) => void
  onCustomizeClick: () => void
  summaryText: { frequencyPart: string; maxPart: string } | null
}

const PresetCardGrid: React.FC<PresetCardGridProps> = ({
  selectedPreset,
  onPresetSelect,
  onCustomizeClick,
  summaryText,
}) => {
  const [css] = useStyletron()

  const gridStyle = css({
    display: 'grid',
    gap: '8px',
    gridTemplateColumns: 'repeat(3, 1fr)',
    '@media (max-width: 900px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
    },
  })

  return (
    <div className="mt-s">
      <div className={`mb-s ${gridStyle}`}>
        {PRESETS.map(preset => (
          <SelectableCard
            key={preset.key}
            isSelected={selectedPreset === preset.key}
            onClick={() => onPresetSelect(preset.key)}
            ariaLabel={`${preset.title}: ${preset.description}`}
            title={preset.title}
            description={preset.description}
            compact
          />
        ))}
      </div>

      {summaryText && (
        <div
          className="mt-xs"
          style={{
            borderLeft: '3px solid #0073BF',
            backgroundColor: '#F5F8FA',
            padding: '12px 16px',
            borderRadius: '2px',
          }}
        >
          <Text.BodyText4 color="grey70">
            {t('summary_prefix')}{' '}
            <Text.BodyText4 tag="span" bold color="grey70">
              {summaryText.frequencyPart}
            </Text.BodyText4>{' '}
            {t('summary_from_issuance')}
            {summaryText.maxPart && (
              <>
                {' '}
                <Text.BodyText4 tag="span" color="grey70">
                  {summaryText.maxPart}
                </Text.BodyText4>
              </>
            )}
          </Text.BodyText4>
          <div className="mt-xxs">
            <Button
              bsStyle="link"
              className={`p-0 ${css({
                ':focus': {
                  textDecoration: 'none',
                },
              })}`}
              onClick={onCustomizeClick}
            >
              {t('customize_link')} →
            </Button>
          </div>
        </div>
      )}

      {selectedPreset && !summaryText && (
        <Button
          bsStyle="link"
          className={`p-0 mt-xs ${css({
            ':focus': {
              textDecoration: 'none',
            },
          })}`}
          onClick={onCustomizeClick}
        >
          {t('customize_link')} →
        </Button>
      )}
    </div>
  )
}

export default PresetCardGrid
